import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useState, useEffect } from 'react';
import { utils } from '@atlaskit/util-service-support';
import { timed } from '../../common/clients';
import { SimpleCache } from '../../utils/simple-cache';
import { useJiraSearchClientContext } from './jira-search-provider';
var USER_DATA_URL = '/rest/api/3/user';
export var JiraCurrentUserClient = /*#__PURE__*/function () {
  function JiraCurrentUserClient(_ref) {
    var _this = this;
    var accountId = _ref.accountId,
      baseUrl = _ref.baseUrl,
      currentUserSupplier = _ref.currentUserSupplier;
    _classCallCheck(this, JiraCurrentUserClient);
    _defineProperty(this, "getCurrentUser", function () {
      return _this.currentUserCache.get().value;
    });
    _defineProperty(this, "getUserSupplier", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$_this$makeRequ, result, durationMs;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.makeRequest(USER_DATA_URL);
          case 2:
            _yield$_this$makeRequ = _context.sent;
            result = _yield$_this$makeRequ.result;
            durationMs = _yield$_this$makeRequ.durationMs;
            return _context.abrupt("return", _objectSpread(_objectSpread({}, result), {}, {
              timings: durationMs
            }));
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    this.serviceConfig = {
      url: baseUrl
    };
    this.accountId = accountId;
    this.currentUserCache = new SimpleCache(currentUserSupplier || this.getUserSupplier);
  }
  _createClass(JiraCurrentUserClient, [{
    key: "makeRequest",
    value: function () {
      var _makeRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(path) {
        var options;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              options = {
                path: path,
                queryParams: {
                  accountId: this.accountId,
                  expand: 'applicationRoles'
                }
              };
              return _context2.abrupt("return", timed(utils.requestService(this.serviceConfig, options)));
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function makeRequest(_x) {
        return _makeRequest.apply(this, arguments);
      }
      return makeRequest;
    }()
  }]);
  return JiraCurrentUserClient;
}();
export var useJiraCurrentUser = function useJiraCurrentUser() {
  var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loadingComplete = _useState2[0],
    setLoadingComplete = _useState2[1];
  var _useState3 = useState(user),
    _useState4 = _slicedToArray(_useState3, 2),
    currentUser = _useState4[0],
    setCurrentUser = _useState4[1];
  var _useJiraSearchClientC = useJiraSearchClientContext(),
    currentUserClient = _useJiraSearchClientC.currentUserClient;
  useEffect(function () {
    if (!loadingComplete) {
      var shouldUpdate = true;
      currentUserClient === null || currentUserClient === void 0 || currentUserClient.getCurrentUser().then(function (result) {
        if (shouldUpdate && !loadingComplete) {
          setCurrentUser({
            id: result.accountId,
            name: result.displayName,
            avatarUrl: result.avatarUrls['24x24'],
            email: result.emailAddress,
            hasSoftwareAccess: result.applicationRoles.items.some(function (item) {
              return item.key === 'jira-software';
            })
          });
          setLoadingComplete(true);
        }
      }).catch(function () {}); // swallow any errors

      return function () {
        shouldUpdate = false;
      };
    }
  }, [currentUserClient, loadingComplete]);
  return currentUser;
};